<template> 

<v-container class="pa-0">

  <v-autocomplete
    hide-selected 
    @change="user.formChange = true" 
    label="Actieve organisatie" 
    v-model="user.organisation_reference"
    :items="user.organisations" 
    item-text="name" 
    item-value="reference" 
    >
        <template v-slot:append-outer>
            <v-icon
              color="success"
              v-text="'mdi-plus'"
              @click="show = true"
            ></v-icon>                 
        </template>     
  </v-autocomplete>

    <v-dialog
      v-model="show"
      width="600" class="d-dialog">

      <v-card class="custom-card resize">

      <v-card
          :color="app.color"
          :height="headerHeight(this.$vuetify)"
          >
        <v-container class="fill-height">               
          <v-layout wrap justify-center="" align-center="" class="text-center">
            <v-flex xs12 class="text-center">
              <v-layout justify-center="" fill-height="" wrap>
                <v-flex xs12>
                  <v-icon color="white" size="75">mdi-earth</v-icon>
                </v-flex>
                <v-flex xs12>
                  <span class="headline font-weight-thin white--text">Organisatie toevoegen</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>               
        </v-container>       
      </v-card>
      
      <v-layout wrap class="pa-3">
        <v-flex xs12 class="pl-1" >
          <v-form v-model="valid">
            <v-text-field :rules="[v => !!v || 'Naam is verplicht']"  label="Naam" v-model="name"></v-text-field>                       
          </v-form>
        </v-flex>          
      </v-layout>
      
      <v-layout justify-center="" style="min-height:78px;">
          <v-expand-transition>
              <v-layout justify-center="">
              <v-flex xs8>
                  <v-btn rounded block color="success" :disabled="!valid" @click="createOrganisation()">Organisatie aanmaken</v-btn>
              </v-flex>
              </v-layout>
          </v-expand-transition>
      </v-layout>                
    </v-card>
    </v-dialog>

</v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    name: "",
    show: false,
    valid: false
  }),
  methods: {
    createOrganisation() {
      this.$store.dispatch(
        "user/createOrganisation",
        { name: this.name },
        { root: true }
      );
    }
  },
  computed: {
    ...mapState(["user", "app"]),
    ...mapGetters(["headerHeight"])
  }
};
</script>

<style scoped>
.custom-card {
  border-radius: 20px !important;
}
.resize {
  min-height: 75vh;
}

.repeating-gradient {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(231, 231, 231, 0.1),
    rgba(231, 231, 231, 0.1),
    rgba(0, 49, 87, 0) 8px,
    rgba(0, 49, 87, 0) 15px
  );
}

.expand-x-transition {
  transition: all 4s ease;
}
</style>